var render = function render(_c,_vm){return _c('span',{staticClass:"fas fa-spinner d-inline-block spin",style:({ 'font-size': _vm.props.size }),attrs:{"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }